import React from 'react'

export const useBrandAccountSurveyGroupsQueryKey = (
  brandAccountId: string | undefined,
) =>
  React.useMemo(
    () =>
      ['UseBrandAccountSurveyGroupsQuery_Main', { brandAccountId }] as const,
    [brandAccountId],
  )
